/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum BlockedIpStatuses {
  Banned = "Banned",
  Requested = "Requested",
  Unbanning = "Unbanning",
}

export enum BlockedIpTypes {
  Fail2Ban = "Fail2Ban",
  GlobalBlocklist = "GlobalBlocklist",
  NDTBlocklist = "NDTBlocklist",
}

export enum CallBackTypes {
  CallersInTheQueue = "CallersInTheQueue",
  ExpectedHoldTime = "ExpectedHoldTime",
}

export enum CallDirectionTypes {
  Inbound = "Inbound",
  Internal = "Internal",
  Outbound = "Outbound",
  System = "System",
}

export enum CallDispositionTypes {
  Abandoned = "Abandoned",
  Answered = "Answered",
  Missed = "Missed",
  QueueCallBack = "QueueCallBack",
  Rejected = "Rejected",
  Unknown = "Unknown",
  Voicemail = "Voicemail",
}

export enum CallRetentionPolicyTypes {
  Eighteen = "Eighteen",
  NegativeOne = "NegativeOne",
  Sixty = "Sixty",
  ThirtySix = "ThirtySix",
}

export enum DayOfWeek {
  Friday = "Friday",
  Monday = "Monday",
  Saturday = "Saturday",
  Sunday = "Sunday",
  Thursday = "Thursday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
}

export enum DeviceTypes {
  CCX400 = "CCX400",
  CCX500 = "CCX500",
  CCX600 = "CCX600",
  EdgeB30 = "EdgeB30",
  EdgeE220 = "EdgeE220",
  EdgeE320 = "EdgeE320",
  EdgeE350 = "EdgeE350",
  EdgeE450 = "EdgeE450",
  IP450 = "IP450",
  IP6000 = "IP6000",
  Model320 = "Model320",
  Model330 = "Model330",
  Model335 = "Model335",
  Model430 = "Model430",
  Model450 = "Model450",
  Model550 = "Model550",
  Model650 = "Model650",
  Model840 = "Model840",
  RoveB2 = "RoveB2",
  RoveB4 = "RoveB4",
  Trio8300 = "Trio8300",
  Trio8500 = "Trio8500",
  Trio8800 = "Trio8800",
  TrioC60 = "TrioC60",
  VVX150 = "VVX150",
  VVX250 = "VVX250",
  VVX300 = "VVX300",
  VVX310 = "VVX310",
  VVX311 = "VVX311",
  VVX350 = "VVX350",
  VVX400 = "VVX400",
  VVX410 = "VVX410",
  VVX411 = "VVX411",
  VVX450 = "VVX450",
  VVX500 = "VVX500",
  VVX501 = "VVX501",
  VVX600 = "VVX600",
  VVX601 = "VVX601",
  VVXD230 = "VVXD230",
}

export enum ExtensionTypes {
  AutoAttendant = "AutoAttendant",
  CallQueue = "CallQueue",
  Directory = "Directory",
  ExternalForward = "ExternalForward",
  Fax = "Fax",
  FindMeFollowMe = "FindMeFollowMe",
  Hangup = "Hangup",
  HuntGroup = "HuntGroup",
  PagingGroup = "PagingGroup",
  Phone = "Phone",
  SmartVoicemail = "SmartVoicemail",
  VoiceMailbox = "VoiceMailbox",
}

export enum FaxFileTypes {
  PDF = "PDF",
  TIFF = "TIFF",
}

export enum FaxStatuses {
  Errored = "Errored",
  InProcess = "InProcess",
  Pending = "Pending",
  Successful = "Successful",
}

export enum FaxTypes {
  Received = "Received",
  Sent = "Sent",
}

export enum LogCodes {
  ARIConnection = "ARIConnection",
  HungUpCall = "HungUpCall",
  LineLimitExceeded = "LineLimitExceeded",
}

export enum LogLevels {
  Critical = "Critical",
  Debug = "Debug",
  Error = "Error",
  Info = "Info",
  Verbose = "Verbose",
  Warning = "Warning",
}

export enum MailboxFolders {
  Family = "Family",
  Friends = "Friends",
  Inbox = "Inbox",
  Old = "Old",
  Work = "Work",
}

export enum NameDirectoryPreference {
  Disabled = "Disabled",
  FirstAndLastName = "FirstAndLastName",
  FirstNameOnly = "FirstNameOnly",
  LastNameOnly = "LastNameOnly",
}

export enum NullActionTypes {
  Directory = "Directory",
  Hangup = "Hangup",
  Unset = "Unset",
  Voicemail = "Voicemail",
}

export enum OrderingDirections {
  Asc = "Asc",
  Desc = "Desc",
  NotSet = "NotSet",
}

export enum PhoneTypes {
  Appsuite = "Appsuite",
  Handset = "Handset",
  Hardphone = "Hardphone",
  Softphone = "Softphone",
}

export enum PromptTypes {
  AutoAttendant = "AutoAttendant",
  ClosedException = "ClosedException",
  MusicOnHold = "MusicOnHold",
  PeriodicAnnouncement = "PeriodicAnnouncement",
  QueueCallback = "QueueCallback",
  SystemPrompt = "SystemPrompt",
  VoiceMailGreeting = "VoiceMailGreeting",
}

export enum Providers {
  Inteliquent = "Inteliquent",
  Lumen = "Lumen",
  NDT = "NDT",
  TimeWarner = "TimeWarner",
  Twilio = "Twilio",
}

export enum QueueAgentDialStatuses {
  QueueDialAnswered = "QueueDialAnswered",
  QueueDialInitiated = "QueueDialInitiated",
  QueueDialRejected = "QueueDialRejected",
}

export enum QueueAgentStatus {
  Available = "Available",
  DND = "DND",
  OnThePhone = "OnThePhone",
  Ringing = "Ringing",
}

export enum QueueCallerStatus {
  Abandoned = "Abandoned",
  CallbackRequested = "CallbackRequested",
  ClearedFromQueue = "ClearedFromQueue",
  Connected = "Connected",
  DialingAnAgent = "DialingAnAgent",
  InitiateQueueCallback = "InitiateQueueCallback",
  ToExitRoute = "ToExitRoute",
  Waiting = "Waiting",
}

export enum QueueHistoryDisposition {
  CallAbandoned = "CallAbandoned",
  CallbackFailed = "CallbackFailed",
  CallbackRejected = "CallbackRejected",
  CallerSelectedExitRoute = "CallerSelectedExitRoute",
  ConnectedToAgent = "ConnectedToAgent",
  ManuallyCleared = "ManuallyCleared",
}

export enum QueueManagementStrategy {
  ManagedQueues = "ManagedQueues",
  StandardQueues = "StandardQueues",
}

export enum QueueStrategies {
  FewestCalls = "FewestCalls",
  LeastRecent = "LeastRecent",
  RoundRobin = "RoundRobin",
}

export enum RelativeDateOptions {
  EndOfWeek = "EndOfWeek",
  FifteenDays = "FifteenDays",
  FirstOfWeek = "FirstOfWeek",
  LastQuarter = "LastQuarter",
  LastWeekday = "LastWeekday",
  NinetyDays = "NinetyDays",
  OneMonthAgo = "OneMonthAgo",
  OneWeekAgo = "OneWeekAgo",
  OneYearAgo = "OneYearAgo",
  PreviousTwelveMonths = "PreviousTwelveMonths",
  SixMonths = "SixMonths",
  ThisQuarter = "ThisQuarter",
  Today = "Today",
  TwoDays = "TwoDays",
  TwoWeeks = "TwoWeeks",
  Yesterday = "Yesterday",
}

export enum ReportDefinitions {
  AbandonedCalls = "AbandonedCalls",
  ActiveExtensions = "ActiveExtensions",
  DailyCallVolume = "DailyCallVolume",
  ExtensionDetail = "ExtensionDetail",
  ExtensionStatistics = "ExtensionStatistics",
  ExtensionSummary = "ExtensionSummary",
  HourlyCallVolume = "HourlyCallVolume",
  HuntGroupExtension = "HuntGroupExtension",
  InboundCallsByPhoneNumber = "InboundCallsByPhoneNumber",
  InternationalCalls = "InternationalCalls",
  MissedCalls = "MissedCalls",
  SystemInternationalCalls = "SystemInternationalCalls",
  TopCallers = "TopCallers",
  WeekDayCallVolume = "WeekDayCallVolume",
}

export enum ReportParameters {
  AggregateQueues = "AggregateQueues",
  AutoAttendantExtensionsToInclude = "AutoAttendantExtensionsToInclude",
  BarGraphSource = "BarGraphSource",
  Boolean = "Boolean",
  CallDirectionsToInclude = "CallDirectionsToInclude",
  CallDispositionsToInclude = "CallDispositionsToInclude",
  CallQueueExtensionsToInclude = "CallQueueExtensionsToInclude",
  ColumnSort = "ColumnSort",
  DataToInclude = "DataToInclude",
  DateRange = "DateRange",
  DateRangeSelect = "DateRangeSelect",
  DaysOfTheWeek = "DaysOfTheWeek",
  EndHour = "EndHour",
  ExcludeInternal = "ExcludeInternal",
  ExtensionGroupsToInclude = "ExtensionGroupsToInclude",
  ExtensionSortBy = "ExtensionSortBy",
  ExtensionsToInclude = "ExtensionsToInclude",
  GroupByExtension = "GroupByExtension",
  IncludeNotMissedCalls = "IncludeNotMissedCalls",
  NumberOfCallers = "NumberOfCallers",
  PhoneNumbersToInclude = "PhoneNumbersToInclude",
  SelectedAccount = "SelectedAccount",
  ShowDate = "ShowDate",
  SingleDate = "SingleDate",
  SortBy = "SortBy",
  StartHour = "StartHour",
  SummaryOnly = "SummaryOnly",
  TimeRange = "TimeRange",
  TimeZone = "TimeZone",
}

export enum SystemLogAreas {
  Broadcast = "Broadcast",
  CallRecordings = "CallRecordings",
  Calls = "Calls",
  DeviceManagement = "DeviceManagement",
  Fax = "Fax",
  LogLevelUpdate = "LogLevelUpdate",
  Migration = "Migration",
  Osips = "Osips",
  Queues = "Queues",
  Voicemails = "Voicemails",
}

export enum SystemLogSeverities {
  High = "High",
  Low = "Low",
  Medium = "Medium",
}

export enum SystemLogTypes {
  Delete = "Delete",
  Insert = "Insert",
  Miscellaneous = "Miscellaneous",
  Security = "Security",
  StasisException = "StasisException",
  Update = "Update",
}

export enum TileSets {
  CallParking = "CallParking",
  Clock = "Clock",
  NdtWaitTimes = "NdtWaitTimes",
  PhoneQueues = "PhoneQueues",
  QueueMembers = "QueueMembers",
}

export enum TileTypes {
  BarGraph = "BarGraph",
  Clock = "Clock",
  LineGraph = "LineGraph",
  PieGraph = "PieGraph",
  PieGridGraph = "PieGridGraph",
  Summary = "Summary",
  Table = "Table",
}

export enum TileViewModes {
  Large = "Large",
  Medium = "Medium",
  Small = "Small",
}

export enum Tiles {
  CallParking = "CallParking",
  Clock = "Clock",
  NDTWaitTimesGraph = "NDTWaitTimesGraph",
  PhoneQueues = "PhoneQueues",
  QueueMembers = "QueueMembers",
}

export enum TimeZones {
  Alaska = "Alaska",
  Arizona = "Arizona",
  Atlantic = "Atlantic",
  Central = "Central",
  Eastern = "Eastern",
  Hawaii = "Hawaii",
  Mountain = "Mountain",
  Pacific = "Pacific",
  Saskatchewan = "Saskatchewan",
}

export enum Versions {
  NDT1 = "NDT1",
  NDT2 = "NDT2",
}

export interface AccessTokenInput {
  accessTokenId?: any | null;
  token?: string | null;
  userId?: number | null;
  accountId?: any | null;
  fields: string[];
}

export interface AccountInput {
  accountId?: any | null;
  name?: string | null;
  shortName?: string | null;
  activeStartDate?: any | null;
  activeEndDate?: any | null;
  isSuspended?: boolean | null;
  fileStoreId?: any | null;
  holdMusicPromptId?: any | null;
  lcsAccountNumber?: number | null;
  isResidential?: boolean | null;
  pdmsSubOrgId?: string | null;
  provisioningPassword?: string | null;
  namespace?: string | null;
  isCallRecordingFeatureEnabled?: boolean | null;
  isRecordInternalCalls?: boolean | null;
  isRecordOutboundCalls?: boolean | null;
  isRecordInboundCalls?: boolean | null;
  isMailboxMessageTranscriptionEnabled?: boolean | null;
  defaultAreaCode?: any | null;
  callRetentionPolicyTypeId?: CallRetentionPolicyTypes | null;
  timeZoneId?: TimeZones | null;
  centralId?: any | null;
  versionId?: Versions | null;
  operatorExtensionId?: any | null;
  presenceUser?: string | null;
  nameDirectoryPreferenceId?: NameDirectoryPreference | null;
  pstnLineLimit?: any | null;
  isInternationalDialingEnabled?: boolean | null;
  isInternationalDialingSuspended?: boolean | null;
  callCostDailyLimit?: any | null;
  outboundRecordingNotificationEnabled?: boolean | null;
  domain?: string | null;
  isMissedCallsShown?: boolean | null;
  isFmFmEnabled?: boolean | null;
  isLcsInternal?: boolean | null;
  operatorExtension?: ExtensionInput | null;
  phoneNumbers?: PhoneNumberInput[] | null;
  extensions?: ExtensionInput[] | null;
  extensionGroups?: ExtensionGroupInput[] | null;
  holdMusicPrompt?: PromptInput | null;
  locations?: LocationInput[] | null;
  isOtrEnabled?: boolean | null;
  logLevelId?: LogLevels | null;
  faxFileTypeId?: FaxFileTypes | null;
  hashedProvisioningPasswordOld?: string | null;
  reasonLogLevelChanged?: string | null;
  logLevelChanged?: any | null;
  scheduleId?: any | null;
  departments?: DepartmentInput[] | null;
  schedule?: ScheduleInput | null;
  note?: NoteInput | null;
  isWhisperTranscriptionEnabled?: boolean | null;
  externalNumbers?: ExternalNumberHistoryInput[] | null;
  queueManagementStrategyTypeId?: QueueManagementStrategy | null;
  isAgentCanAssign?: boolean | null;
  presenceEnabled?: boolean | null;
  logLevelChangedByUserId?: any | null;
  logLevelChangedByUser?: UserInput | null;
  fields: string[];
}

export interface AggregateQueuesReportParameterInput {
  value?: boolean | null;
  isAskParameter?: boolean | null;
  sortOrder?: number | null;
  parameterType?: ReportParameters | null;
  fields: string[];
}

export interface AllowedIpAddressInput {
  allowedIpAddressId?: any | null;
  ipAddress?: string | null;
  accountId?: any | null;
  qManageTicketId?: string | null;
  originatingType?: number | null;
  status?: number | null;
  fields: string[];
}

export interface AutoAttendantKeyInput {
  autoAttendantKeyId?: any | null;
  extensionId?: any | null;
  extensionAutoAttendantId?: any | null;
  keyNumber?: string | null;
  routeTo?: any | null;
  voiceMailOnly?: boolean | null;
  nameDirectoryOnly?: boolean | null;
  routeToNullAction?: NullActionTypes | null;
  fields: string[];
}

export interface AutoAttendantPromptInput {
  autoAttendantPromptId?: any | null;
  extensionId?: any | null;
  extensionAutoAttendantId?: any | null;
  sortId?: any | null;
  promptId?: any | null;
  fields: string[];
}

export interface BaseStationHandsetInput {
  baseStationHandsetId?: any | null;
  deviceId?: any | null;
  phoneId?: any | null;
  sortId?: any | null;
  device?: DeviceInput | null;
  fields: string[];
}

export interface BlockedIpAddressInput {
  blockedIpAddressId?: any | null;
  ipAddress?: string | null;
  type?: BlockedIpTypes | null;
  status?: BlockedIpStatuses | null;
  fields: string[];
}

export interface BlockedPhoneNumberInput {
  blockedPhoneNumberId?: any | null;
  accountId?: any | null;
  phoneNumber?: string | null;
  comment?: string | null;
  fields: string[];
}

export interface CallDetailInput {
  callDetailId?: any | null;
  accountId?: any | null;
  serverId?: any | null;
  callDispositionTypeId?: CallDispositionTypes | null;
  callDirectionTypeId?: CallDirectionTypes | null;
  callRecordingId?: any | null;
  startTime?: any | null;
  endTime?: any | null;
  sourceExtensionId?: any | null;
  sourceNumber?: string | null;
  callerChannelId?: string | null;
  destinationExtensionId?: any | null;
  destinationNumber?: string | null;
  phoneNumberId?: any | null;
  providerId?: Providers | null;
  callerName?: string | null;
  serverName?: string | null;
  sipCallId?: string | null;
  callRate?: number | null;
  callCost?: number | null;
  otrTriggered?: boolean | null;
  originalDestinationNumber?: string | null;
  sourceIpAddress?: string | null;
  destinationIpAddress?: string | null;
  stirShakenVerification?: number | null;
  stirShakenToken?: string | null;
  stirShakenAttest?: string | null;
  sourceProviderId?: Providers | null;
  destinationProviderId?: Providers | null;
  fields: string[];
}

export interface CallParkingTileReportParametersInput {
  selectedAccount?: SelectedAccountReportParameterInput | null;
  tileLayoutConfiguration?: TileLayoutConfigurationParameterInput | null;
  limit?: number | null;
  aggregateRest?: boolean | null;
  timeZone?: TimeZoneReportParameterInput | null;
  fields: string[];
}

export interface CallQueueExtensionsToIncludeReportParameterInput {
  accountId?: any | null;
  all?: boolean | null;
  values?: any[] | null;
  names?: (string | null)[] | null;
  isAskParameter?: boolean | null;
  sortOrder?: number | null;
  parameterType?: ReportParameters | null;
  fields: string[];
}

export interface ClockTileReportParametersInput {
  showDate?: ShowDateReportParameterInput | null;
  tileLayoutConfiguration?: TileLayoutConfigurationParameterInput | null;
  limit?: number | null;
  aggregateRest?: boolean | null;
  timeZone?: TimeZoneReportParameterInput | null;
  fields: string[];
}

export interface ClosedExceptionInput {
  closedExceptionId?: any | null;
  startDate?: any | null;
  endDate?: any | null;
  startTime?: any | null;
  endTime?: any | null;
  scheduleId?: any | null;
  promptId?: any | null;
  schedule?: ScheduleInput | null;
  prompt?: PromptInput | null;
  fields: string[];
}

export interface ColumnSortReportParameterInput {
  value?: string | null;
  isAskParameter?: boolean | null;
  sortOrder?: number | null;
  parameterType?: ReportParameters | null;
  fields: string[];
}

export interface DashboardInput {
  dashboardId?: any | null;
  userId?: number | null;
  name?: string | null;
  lastSavedColumnLayoutSize?: number | null;
  fields: string[];
}

export interface DashboardTileEntityParameterInput {
  dashboardTileEntityParameterId?: any | null;
  all?: boolean | null;
  includeNull?: boolean | null;
  fields: string[];
}

export interface DashboardTileInput {
  dashboardTileId?: any | null;
  dashboardId?: any | null;
  tileId?: Tiles | null;
  totalTimesProcessed?: any | null;
  totalMillisecondsProcessed?: any | null;
  dashboardTileLayoutConfiguration?: DashboardTileLayoutConfigurationInput | null;
  dashboard?: DashboardInput | null;
  dashboardTileParameters?: DashboardTileParameterInput[] | null;
  tile?: TileInput | null;
  tileViewMode?: TileViewModes | null;
  fields: string[];
}

export interface DashboardTileLayoutConfigurationInput {
  dashboardTileLayoutConfigurationId?: any | null;
  dashboardTileId?: any | null;
  name?: string | null;
  minWidth?: number | null;
  minHeight?: number | null;
  maxWidth?: number | null;
  maxHeight?: number | null;
  width?: number | null;
  height?: number | null;
  column?: number | null;
  row?: number | null;
  color?: string | null;
  refreshTimeSeconds?: number | null;
  fields: string[];
}

export interface DashboardTileParameterDateRangeInput {
  dashboardTileParameterDateRangeId?: any | null;
  startDate?: any | null;
  endDate?: any | null;
  relativeDate?: RelativeDateOptions | null;
  relativeStartDate?: string | null;
  relativeEndDate?: string | null;
  field?: string | null;
  filterByDateRange?: boolean | null;
  fields: string[];
}

export interface DashboardTileParameterInput {
  dashboardTileParameterId?: any | null;
  dashboardTileId?: any | null;
  valueDateRangeParameterId?: any | null;
  valueNumeric?: any | null;
  valueEntitiesToIncludeId?: any | null;
  valueString?: string | null;
  valueDateTime?: any | null;
  valueBool?: boolean | null;
  sortOrder?: number | null;
  isAskParameter?: boolean | null;
  parameterType?: ReportParameters | null;
  dateRange?: DashboardTileParameterDateRangeInput | null;
  entitiesToInclude?: DashboardTileEntityParameterInput | null;
  dashboardTile?: DashboardTileInput | null;
  fields: string[];
}

export interface DepartmentExtensionInput {
  departmentExtensionId?: any | null;
  departmentId?: any | null;
  extensionId?: any | null;
  department?: DepartmentInput | null;
  extension?: ExtensionInput | null;
  fields: string[];
}

export interface DepartmentInput {
  departmentId?: any | null;
  accountId?: any | null;
  name?: string | null;
  isActive?: boolean | null;
  departmentExtensions?: DepartmentExtensionInput[] | null;
  fields: string[];
}

export interface DeviceInput {
  deviceId?: any | null;
  description?: string | null;
  accountId?: any | null;
  phoneId?: any | null;
  macAddress?: string | null;
  serialNumber?: string | null;
  lastFirmwareReported?: string | null;
  lastProvisionedDate?: any | null;
  deviceTypeId?: DeviceTypes | null;
  ztStatus?: boolean | null;
  lastZtResponse?: string | null;
  notes?: string | null;
  centralId?: any | null;
  account?: AccountInput | null;
  phone?: PhoneInput | null;
  deviceType?: DeviceTypeInput | null;
  baseStationHandsets?: BaseStationHandsetInput[] | null;
  devices?: DeviceInput[] | null;
  fields: string[];
}

export interface DeviceTypeInput {
  deviceTypeId?: number | null;
  name?: string | null;
  externalProvisioningSystemTypeId?: any | null;
  deviceSoftwareStreamTypeId?: any | null;
  fields: string[];
}

export interface ExecuteTilePostModelCallParkingTileReportParametersInput {
  parameters?: CallParkingTileReportParametersInput | null;
  tileViewMode?: TileViewModes | null;
  pageSize?: number | null;
  pageNumber?: number | null;
  dashboardTileId?: number | null;
  tileId?: Tiles | null;
  fields: string[];
}

export interface ExecuteTilePostModelClockTileReportParametersInput {
  parameters?: ClockTileReportParametersInput | null;
  tileViewMode?: TileViewModes | null;
  pageSize?: number | null;
  pageNumber?: number | null;
  dashboardTileId?: number | null;
  tileId?: Tiles | null;
  fields: string[];
}

export interface ExecuteTilePostModelPhoneQueuesTileReportParametersInput {
  parameters?: PhoneQueuesTileReportParametersInput | null;
  tileViewMode?: TileViewModes | null;
  pageSize?: number | null;
  pageNumber?: number | null;
  dashboardTileId?: number | null;
  tileId?: Tiles | null;
  fields: string[];
}

export interface ExecuteTilePostModelQueueMembersTileReportParametersInput {
  parameters?: QueueMembersTileReportParametersInput | null;
  tileViewMode?: TileViewModes | null;
  pageSize?: number | null;
  pageNumber?: number | null;
  dashboardTileId?: number | null;
  tileId?: Tiles | null;
  fields: string[];
}

export interface ExecuteTilePostModelWaitTimesTileReportParametersInput {
  parameters?: WaitTimesTileReportParametersInput | null;
  tileViewMode?: TileViewModes | null;
  pageSize?: number | null;
  pageNumber?: number | null;
  dashboardTileId?: number | null;
  tileId?: Tiles | null;
  fields: string[];
}

export interface ExtensionAutoAttendantInput {
  extensionAutoAttendantId?: any | null;
  extensionId?: any | null;
  timeoutSeconds?: any | null;
  timeoutExtensionId?: any | null;
  firstPromptNotSkippable?: boolean | null;
  timeoutNullAction?: NullActionTypes | null;
  isTimeoutVoicemailOnly?: boolean | null;
  autoAttendantPrompts?: AutoAttendantPromptInput[] | null;
  autoAttendantKeys?: AutoAttendantKeyInput[] | null;
  fields: string[];
}

export interface ExtensionExternalForwardInput {
  extensionExternalForwardId?: any | null;
  extensionId?: any | null;
  forwardToNumber?: string | null;
  isPassthroughOriginalCallerId?: boolean | null;
  dtmf?: string | null;
  pauseSeconds?: any | null;
  isDtmf?: boolean | null;
  fields: string[];
}

export interface ExtensionFaxInput {
  extensionFaxId?: any | null;
  extensionId?: any | null;
  defaultPhoneNumberId?: any | null;
  emailAddress?: string | null;
  faxEmailAddresses?: FaxEmailAddressInput[] | null;
  fields: string[];
}

export interface ExtensionFmFmInput {
  extensionFmFmId?: any | null;
  extensionId?: any | null;
  finalDestinationExtensionId?: any | null;
  isFinalDestinationVoicemail?: boolean | null;
  finalDestinationPhoneNumber?: string | null;
  defaultPhoneNumberId?: any | null;
  isIgnoreForward?: boolean | null;
  isGreetingDisabled?: boolean | null;
  isSendOriginalCallerId?: boolean | null;
  extension?: ExtensionInput | null;
  finalDestinationExtension?: ExtensionInput | null;
  defaultPhoneNumber?: PhoneNumberInput | null;
  fmFmSteps?: FmFmStepInput[] | null;
  fields: string[];
}

export interface ExtensionGroupExtensionInput {
  extensionGroupExtensionId?: any | null;
  extensionId?: any | null;
  extensionGroupId?: any | null;
  forwardPhoneNumber?: string | null;
  fields: string[];
}

export interface ExtensionGroupInput {
  extensionGroupId?: any | null;
  accountId?: any | null;
  name?: string | null;
  description?: string | null;
  extensionGroupExtensions?: ExtensionGroupExtensionInput[] | null;
  queueExtensionGroups?: QueueExtensionGroupInput[] | null;
  fields: string[];
}

export interface ExtensionGroupSuperviseeInput {
  extensionGroupSuperviseeId?: any | null;
  supervisorExtensionId?: any | null;
  superviseeExtensionGroupId?: any | null;
  fields: string[];
}

export interface ExtensionHuntGroupInput {
  extensionHuntGroupId?: any | null;
  extensionId?: any | null;
  displayName?: string | null;
  ringTimeout?: number | null;
  callerIdOverride?: boolean | null;
  routeBusyExtensionId?: any | null;
  routeNoAnswerExtensionId?: any | null;
  isRouteBusyVoicemailOnly?: boolean | null;
  isRouteNoAnswerVoicemailOnly?: boolean | null;
  routeBusyNullAction?: NullActionTypes | null;
  routeNoAnswerNullAction?: NullActionTypes | null;
  huntGroupMembers?: HuntGroupMemberInput[] | null;
  extensionGroupHuntGroupMembers?: HuntGroupExtensionGroupInput[] | null;
  huntGroupExtensionGroups?: HuntGroupExtensionGroupInput[] | null;
  fields: string[];
}

export interface ExtensionInput {
  extensionId?: any | null;
  name?: string | null;
  number?: any | null;
  accountId?: any | null;
  type?: ExtensionTypes | null;
  mailboxId?: any | null;
  timeZoneId?: TimeZones | null;
  locationId?: any | null;
  locationTimeZoneId?: TimeZones | null;
  accountTimeZoneId?: TimeZones | null;
  extensionQueueHoldMusicFileId?: any | null;
  accountHoldMusicFileId?: any | null;
  mailboxOperatorExtensionId?: any | null;
  accountOperatorExtensionId?: any | null;
  isArchived?: boolean | null;
  departmentName?: string | null;
  shortName?: string | null;
  account?: AccountInput | null;
  users?: UserInput[] | null;
  mailbox?: MailboxInput | null;
  mailboxOperatorExtension?: ExtensionInput | null;
  extensionType?: ExtensionTypeInput | null;
  extensionPhone?: ExtensionPhoneInput | null;
  phones?: PhoneInput[] | null;
  extensionAutoAttendant?: ExtensionAutoAttendantInput | null;
  extensionExternalForward?: ExtensionExternalForwardInput | null;
  extensionHuntGroup?: ExtensionHuntGroupInput | null;
  timeBasedRoutes?: TimeBasedRouteInput[] | null;
  extensionMailbox?: ExtensionMailboxInput | null;
  extensionQueue?: ExtensionQueueInput | null;
  location?: LocationInput | null;
  extensionFax?: ExtensionFaxInput | null;
  faxEmailAddresses?: FaxEmailAddressInput[] | null;
  extensionFmFm?: ExtensionFmFmInput | null;
  extensionPagingGroup?: ExtensionPagingGroupInput | null;
  queuesAsAgent?: QueueMemberInput[] | null;
  queueExtensionStatus?: QueueExtensionStatusInput | null;
  rm12Client?: RM12ClientInput | null;
  rm12ClientToken?: Rm12ClientTokenInput | null;
  departmentExtensions?: DepartmentExtensionInput[] | null;
  adminNote?: NoteInput | null;
  extensionNote?: NoteInput | null;
  fields: string[];
}

export interface ExtensionMailboxInput {
  extensionMailboxId?: any | null;
  extensionId?: any | null;
  timeZoneId?: TimeZones | null;
  notes?: string | null;
  customerNotes?: string | null;
  fields: string[];
}

export interface ExtensionPagingGroupInput {
  extensionPagingGroupId?: any | null;
  extensionId?: any | null;
  extensionPagingGroupExtension?: ExtensionInput | null;
  pagingGroupExtensionGroups?: PagingGroupExtensionGroupInput[] | null;
  pagingGroupMembers?: PagingGroupMemberInput[] | null;
  fields: string[];
}

export interface ExtensionPhoneInput {
  extensionPhoneId?: any | null;
  extensionId?: any | null;
  ringTimeout?: any | null;
  displayName?: string | null;
  defaultPhoneNumberId?: any | null;
  forwardExtensionId?: any | null;
  forwardExternalNumber?: string | null;
  routeBusyExtensionId?: any | null;
  routeNoAnswerExtensionId?: any | null;
  enableDtmf?: boolean | null;
  secondsToWait?: any | null;
  dtmfToPlay?: string | null;
  isOtrEnabled?: boolean | null;
  dndStatus?: string | null;
  dndStatusChangedDate?: any | null;
  logoutReason?: string | null;
  logoutReasonChangedDate?: any | null;
  office?: string | null;
  isAutoAnswer?: boolean | null;
  isRingAllPhones?: boolean | null;
  autoAnswerPhoneId?: any | null;
  isAutoAnswerEnabled?: boolean | null;
  routeBusyNullAction?: NullActionTypes | null;
  routeNoAnswerNullAction?: NullActionTypes | null;
  defaultAreaCode?: any | null;
  phones?: PhoneInput[] | null;
  extensionSupervisees?: ExtensionSuperviseeInput[] | null;
  extensionGroupSupervisees?: ExtensionGroupSuperviseeInput[] | null;
  autoAnswerPhone?: PhoneInput | null;
  callDetailId?: any | null;
  isLoggedIntoQueues?: boolean | null;
  fields: string[];
}

export interface ExtensionQueueInput {
  extensionQueueId?: any | null;
  extensionId?: any | null;
  queueStrategyId?: QueueStrategies | null;
  holdMusicPromptId?: any | null;
  exitRouteTo?: any | null;
  wrapUpTime?: any | null;
  announcementFrequency?: any | null;
  isAnnounceWaitTime?: boolean | null;
  isAnnounceQueueCount?: boolean | null;
  isAnnounceCallback?: boolean | null;
  exitRouteVoicemailOnly?: boolean | null;
  isCallBackAvailable?: boolean | null;
  callersNeededForCallback?: any | null;
  callbackAttempts?: any | null;
  customCallbackPromptId?: any | null;
  periodicAnnouncementFrequency?: any | null;
  lastConnectedMemberId?: any | null;
  hasPreventEmptyQueue?: boolean | null;
  queueEmptyExitRouteTo?: any | null;
  queueEmptyExitNullAction?: NullActionTypes | null;
  queueMembers?: QueueMemberInput[] | null;
  queueExtensionGroupMembers?: QueueExtensionGroupInput[] | null;
  queuePeriodicAnnouncements?: QueuePeriodicAnnouncementInput[] | null;
  exitRouteToExtension?: ExtensionInput | null;
  extension?: ExtensionInput | null;
  holdMusicPrompt?: PromptInput | null;
  callbackPrompt?: PromptInput | null;
  lastConnectedMember?: QueueMemberInput | null;
  queueEmptyExitRouteToExtension?: ExtensionInput | null;
  callBackType?: CallBackTypes | null;
  holdTimeNeededForCallback?: any | null;
  fields: string[];
}

export interface ExtensionSuperviseeInput {
  extensionSuperviseeId?: any | null;
  supervisorExtensionId?: any | null;
  superviseeExtensionId?: any | null;
  fields: string[];
}

export interface ExtensionTypeInput {
  extensionTypeId?: ExtensionTypes | null;
  name?: string | null;
  description?: string | null;
  displayName?: string | null;
  fields: string[];
}

export interface ExternalNumberHistoryInput {
  externalNumberHistoryId?: any | null;
  accountId?: any | null;
  externalNumber?: string | null;
  fields: string[];
}

export interface FaxEmailAddressInput {
  faxEmailAddressId?: any | null;
  extensionId?: any | null;
  isDomainOnly?: boolean | null;
  emailAddress?: string | null;
  centralId?: any | null;
  fields: string[];
}

export interface FileDepotInput {
  fileDepotId?: any | null;
  name?: string | null;
  path?: string | null;
  fields: string[];
}

export interface FileInput {
  fileId?: any | null;
  fileName?: string | null;
  fileDepotId?: any | null;
  path?: string | null;
  type?: string | null;
  accountId?: any | null;
  size?: any | null;
  isDeleted?: boolean | null;
  displayName?: string | null;
  metaTag?: string | null;
  promptType?: PromptTypes | null;
  isPromptForAccountMoh?: boolean | null;
  isCallRecording?: boolean | null;
  isPromptForExtensionQueueMoh?: boolean | null;
  dontSaveFile?: boolean | null;
  fileDepot?: FileDepotInput | null;
  orphanDate?: any | null;
  account?: AccountInput | null;
  fields: string[];
}

export interface FmFmStepExtensionInput {
  fmFmStepExtensionId?: any | null;
  extensionId?: any | null;
  fmFmStepId?: any | null;
  extension?: ExtensionInput | null;
  fields: string[];
}

export interface FmFmStepInput {
  fmFmStepId?: any | null;
  timeout?: any | null;
  sequence?: any | null;
  extensionFmFmId?: any | null;
  extensionFmFm?: ExtensionFmFmInput | null;
  fmFmStepPhoneNumbers?: FmFmStepPhoneNumberInput[] | null;
  fmFmStepExtensions?: FmFmStepExtensionInput[] | null;
  fields: string[];
}

export interface FmFmStepPhoneNumberInput {
  fmFmStepPhoneNumberId?: any | null;
  fmFmStepId?: any | null;
  phoneNumber?: string | null;
  fields: string[];
}

export interface HuntGroupExtensionGroupInput {
  huntGroupExtensionGroupId?: any | null;
  huntGroupExtensionId?: any | null;
  extensionGroupId?: any | null;
  fields: string[];
}

export interface HuntGroupMemberInput {
  huntGroupMemberId?: any | null;
  extensionHuntGroupId?: any | null;
  extensionId?: any | null;
  fields: string[];
}

export interface LocationInput {
  locationId?: any | null;
  accountId?: any | null;
  name?: string | null;
  houseNumber?: string | null;
  directionalPrefix?: string | null;
  streetName?: string | null;
  streetNameSuffix?: string | null;
  directionalPostfix?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
  country?: string | null;
  comment?: string | null;
  timeZoneId?: TimeZones | null;
  accountTimeZoneId?: TimeZones | null;
  isE911Validated?: boolean | null;
  mostRecentE911ValidationResponse?: string | null;
  fields: string[];
}

export interface MailboxInput {
  mailboxId?: any | null;
  password?: string | null;
  unavailablePromptId2?: any | null;
  namePromptId?: any | null;
  busyPromptId?: any | null;
  temporaryUnavailablePromptId?: any | null;
  emailAddress?: string | null;
  discardAudioAfterEmail?: boolean | null;
  markReadAfterEmail?: boolean | null;
  sayCallerId?: boolean | null;
  lastNameInDigits?: string | null;
  firstNameInDigits?: string | null;
  mailboxMessages?: MailboxMessageInput[] | null;
  operatorExtensionId?: any | null;
  isInNameDirectory?: boolean | null;
  mailboxOperatorExtension?: ExtensionInput | null;
  fields: string[];
}

export interface MailboxMessageInput {
  mailboxMessageId?: any | null;
  mailboxId?: any | null;
  timestamp?: any | null;
  sender?: string | null;
  fileId?: any | null;
  isRead?: boolean | null;
  file?: FileInput | null;
  isArchived?: boolean | null;
  callRecordingId?: any | null;
  mailboxFolderId?: MailboxFolders | null;
  fields: string[];
}

export interface MailboxPostInput {
  mailboxId?: any | null;
  password?: string | null;
  unavailablePromptId2?: any | null;
  temporaryUnavailablePromptId?: any | null;
  namePromptId?: any | null;
  operatorExtensionId?: any | null;
  busyPromptId?: any | null;
  emailAddress?: string | null;
  discardAudioAfterEmail?: boolean | null;
  sayCallerId?: boolean | null;
  markReadAfterEmail?: boolean | null;
  isInNameDirectory?: boolean | null;
  mailboxMessages?: MailboxMessageInput[] | null;
  fields: string[];
}

export interface NoteInput {
  noteId?: any | null;
  accountId?: any | null;
  extensionId?: any | null;
  notes?: string | null;
  isSystemNote?: boolean | null;
  fields: string[];
}

export interface OrderingOption {
  field: string;
  direction?: OrderingDirections | null;
}

export interface PagingGroupExtensionGroupInput {
  pagingGroupExtensionGroupId?: any | null;
  extensionPagingGroupId?: any | null;
  extensionGroupId?: any | null;
  fields: string[];
}

export interface PagingGroupMemberInput {
  pagingGroupMemberId?: any | null;
  extensionPagingGroupId?: any | null;
  extensionId?: any | null;
  extension?: ExtensionInput | null;
  extensionPagingGroup?: ExtensionPagingGroupInput | null;
  fields: string[];
}

export interface PhoneInput {
  phoneId?: any | null;
  phoneType?: PhoneTypes | null;
  extensionId?: any | null;
  handsetIpei?: string | null;
  numberOfLineKeys?: any | null;
  adminPassword?: string | null;
  extension?: ExtensionInput | null;
  extensionPhone?: ExtensionPhoneInput | null;
  sipUsers?: SipUserInput[] | null;
  devices?: DeviceInput[] | null;
  baseStationHandsets?: BaseStationHandsetInput[] | null;
  fields: string[];
}

export interface PhoneNumberInput {
  phoneNumberId?: any | null;
  phoneNumber?: string | null;
  accountId?: any | null;
  displayName?: string | null;
  locationId?: any | null;
  scheduleId?: any | null;
  accountScheduleId?: any | null;
  openExtensionId?: any | null;
  closedExtensionId?: any | null;
  faxExtensionId?: any | null;
  providerId?: Providers | null;
  timeZoneId?: TimeZones | null;
  locationTimeZoneId?: TimeZones | null;
  accountTimeZoneId?: TimeZones | null;
  allowOutboundCalls?: boolean | null;
  isPorted?: boolean | null;
  isE911Registered?: boolean | null;
  portedComments?: string | null;
  datePorted?: any | null;
  isActive?: boolean | null;
  notes?: string | null;
  routeTo?: string | null;
  centralId?: any | null;
  isArchived?: boolean | null;
  openExtension?: ExtensionInput | null;
  closedExtension?: ExtensionInput | null;
  fields: string[];
}

export interface PhoneQueuesTileReportParametersInput {
  selectedAccount?: SelectedAccountReportParameterInput | null;
  callQueueExtensions?: CallQueueExtensionsToIncludeReportParameterInput | null;
  tileLayoutConfiguration?: TileLayoutConfigurationParameterInput | null;
  limit?: number | null;
  aggregateRest?: boolean | null;
  timeZone?: TimeZoneReportParameterInput | null;
  fields: string[];
}

export interface PromptInput {
  promptId?: any | null;
  name?: string | null;
  typeId?: PromptTypes | null;
  isActive?: boolean | null;
  accountId?: any | null;
  fileId?: any | null;
  isReusable?: boolean | null;
  dontDeleteFileOnUpdate?: boolean | null;
  copyMohFile?: boolean | null;
  file?: FileInput | null;
  fields: string[];
}

export interface ProviderCallRateInput {
  providerCallRateId?: number | null;
  providerId?: Providers | null;
  zone?: number | null;
  area?: number | null;
  rate?: number | null;
  destination?: string | null;
  code?: string | null;
  fields: string[];
}

export interface QueueExtensionGroupInput {
  queueExtensionGroupId?: any | null;
  queueExtensionId?: any | null;
  extensionQueueId?: any | null;
  extensionGroupId?: any | null;
  queueMembers?: QueueMemberInput[] | null;
  fields: string[];
}

export interface QueueExtensionStatusInput {
  queueExtensionStatusId?: any | null;
  agentExtensionId?: any | null;
  endWrapUpTime?: any | null;
  lastAttemptTime?: any | null;
  extensionStatus?: QueueAgentStatus | null;
  fields: string[];
}

export interface QueueHistoryInput {
  queueHistoryId?: any | null;
  callDetailId?: any | null;
  startPosition?: number | null;
  callerIdNumber?: string | null;
  callerIdName?: string | null;
  callerStatus?: QueueCallerStatus | null;
  queueExtensionId?: any | null;
  agentExtensionId?: any | null;
  isCallbackRequested?: boolean | null;
  callbackNamePromptFileId?: any | null;
  callDispositionId?: QueueHistoryDisposition | null;
  answeredDateTime?: any | null;
  callbackRequestDateTime?: any | null;
  callbackCompleteDateTime?: any | null;
  callbackAttempts?: number | null;
  callbackFailedDateTime?: any | null;
  callAbandonedDateTime?: any | null;
  initialWaitTimeEstimate?: any | null;
  initialWaitTimeEstimateAlternate?: any | null;
  callCompleteDateTime?: any | null;
  lastAgentDialAttempt?: any | null;
  lastCallbackDialAttempt?: any | null;
  fields: string[];
}

export interface QueueMemberInput {
  queueMemberId?: any | null;
  queueExtensionId?: any | null;
  extensionQueueId?: any | null;
  agentExtensionId?: any | null;
  assignmentUpdatedBy?: any | null;
  isLoggedIn?: boolean | null;
  queueExtensionGroupId?: any | null;
  agentStatus?: QueueAgentStatus | null;
  endWrapUpTime?: any | null;
  isAssigned?: boolean | null;
  queueExtensionStatus?: QueueExtensionStatusInput | null;
  queueExtensionGroup?: QueueExtensionGroupInput | null;
  fields: string[];
}

export interface QueueMembersTileReportParametersInput {
  selectedAccount?: SelectedAccountReportParameterInput | null;
  callQueueExtensions?: CallQueueExtensionsToIncludeReportParameterInput | null;
  columnSort?: ColumnSortReportParameterInput | null;
  tileLayoutConfiguration?: TileLayoutConfigurationParameterInput | null;
  limit?: number | null;
  aggregateRest?: boolean | null;
  timeZone?: TimeZoneReportParameterInput | null;
  fields: string[];
}

export interface QueuePeriodicAnnouncementInput {
  queuePeriodicAnnouncementId?: any | null;
  queueExtensionId?: any | null;
  extensionQueueId?: any | null;
  promptId?: any | null;
  sortOrder?: any | null;
  fields: string[];
}

export interface RM12ClientInput {
  rM12ClientId?: any | null;
  extensionId?: any | null;
  broadcastAccountId?: any | null;
  username?: string | null;
  location?: string | null;
  locationId?: number | null;
  dbid?: string | null;
  rm12UserId?: number | null;
  broadcastUser?: boolean | null;
  versionNumber?: number | null;
  fields: string[];
}

export interface ReportParameterInput {
  reportParameterId?: any | null;
  name?: string | null;
  description?: string | null;
  fields: string[];
}

export interface Rm12ClientTokenInput {
  rm12ClientTokenId?: any | null;
  rM12ClientId?: any | null;
  extensionId?: any | null;
  token?: string | null;
  accountId?: any | null;
  accountShortName?: string | null;
  fields: string[];
}

export interface RoleCallRecordingExtensionGroupInput {
  roleCallRecordingExtensionGroupId?: any | null;
  roleId?: any | null;
  extensionGroupId?: any | null;
  isInclude?: boolean | null;
  fields: string[];
}

export interface RoleCallRecordingExtensionInput {
  roleCallRecordingExtensionId?: any | null;
  roleId?: any | null;
  extensionId?: any | null;
  isInclude?: boolean | null;
  fields: string[];
}

export interface RoleInput {
  roleId?: any | null;
  name?: string | null;
  description?: string | null;
  accountId?: any | null;
  hasAllExtensionRecordings?: boolean | null;
  roleReports?: RoleReportInput[] | null;
  roleCallRecordingExtensions?: RoleCallRecordingExtensionInput[] | null;
  roleCallRecordingExtensionGroups?: RoleCallRecordingExtensionGroupInput[] | null;
  fields: string[];
}

export interface RolePrivilegeInput {
  rolePrivilegeId?: any | null;
  privilegeId?: number | null;
  roleId?: any | null;
  accountId?: any | null;
  isAdd?: boolean | null;
  isView?: boolean | null;
  isEdit?: boolean | null;
  isDelete?: boolean | null;
  isEnabled?: boolean | null;
  fields: string[];
}

export interface RoleReportInput {
  roleReportId?: any | null;
  roleId?: any | null;
  reportId?: number | null;
  fields: string[];
}

export interface ScheduleDetailInput {
  scheduleDetailId?: any | null;
  scheduleId?: any | null;
  dayOfWeek?: DayOfWeek | null;
  openTime?: any | null;
  closeTime?: any | null;
  fields: string[];
}

export interface ScheduleInput {
  scheduleId?: any | null;
  accountId?: any | null;
  name?: string | null;
  description?: string | null;
  scheduleDetails?: ScheduleDetailInput[] | null;
  closedExceptions?: ClosedExceptionInput[] | null;
  phoneNumbers?: PhoneNumberInput[] | null;
  fields: string[];
}

export interface SelectedAccountReportParameterInput {
  value?: any | null;
  name?: string | null;
  isAskParameter?: boolean | null;
  sortOrder?: number | null;
  parameterType?: ReportParameters | null;
  fields: string[];
}

export interface ShowDateReportParameterInput {
  value?: boolean | null;
  isAskParameter?: boolean | null;
  sortOrder?: number | null;
  parameterType?: ReportParameters | null;
  fields: string[];
}

export interface SipUserInput {
  sipUserId?: any | null;
  userName?: string | null;
  hashPassword?: string | null;
  phoneId?: any | null;
  phoneNumberId?: any | null;
  accountId?: any | null;
  subscriberId?: any | null;
  dbAliasId?: any | null;
  legacyDbAliasId?: any | null;
  legacySubscriberId?: any | null;
  isHacked?: boolean | null;
  isFraud?: boolean | null;
  resetSipUserPassword?: boolean | null;
  lastPasswordChange?: any | null;
  fields: string[];
}

export interface TileInput {
  tileId?: Tiles | null;
  name?: string | null;
  description?: string | null;
  designerDescription?: string | null;
  typeId?: TileTypes | null;
  isCustom?: boolean | null;
  canEditRefreshTime?: boolean | null;
  reportParameters?: TileReportParametersInput[] | null;
  tileSetType?: TileSetTypeInput | null;
  fields: string[];
}

export interface TileLayoutConfigurationParameterInput {
  name?: string | null;
  color?: string | null;
  refreshTimeSeconds?: number | null;
  height?: number | null;
  width?: number | null;
  column?: number | null;
  row?: number | null;
  fields: string[];
  timeZone?: TimeZoneReportParameterInput | null;
}

export interface TileReportParametersInput {
  tileReportParameterId?: number | null;
  tileId?: number | null;
  reportParameterId?: number | null;
  tile?: TileInput | null;
  reportParameter?: ReportParameterInput | null;
  fields: string[];
}

export interface TileSetTypeInput {
  tileSetTypeId?: number | null;
  tileSetId?: TileSets | null;
  tileId?: Tiles | null;
  fields: string[];
}

export interface TimeBasedRouteInput {
  timeBasedRouteId?: any | null;
  nDT1TimeBasedRouteId?: number | null;
  extensionId?: any | null;
  startDate?: any | null;
  startTime?: any | null;
  endDate?: any | null;
  endTime?: any | null;
  routeExtensionId?: any | null;
  priorityId?: any | null;
  comment?: string | null;
  isActiveMonday?: boolean | null;
  isActiveTuesday?: boolean | null;
  isActiveWednesday?: boolean | null;
  isActiveThursday?: boolean | null;
  isActiveFriday?: boolean | null;
  isActiveSaturday?: boolean | null;
  isActiveSunday?: boolean | null;
  routeExtensionNullAction?: NullActionTypes | null;
  fields: string[];
}

export interface TimeRangeReportParameterInput {
  startDate?: any | null;
  endDate?: any | null;
  relativeDate?: RelativeDateOptions | null;
  isAskParameter?: boolean | null;
  sortOrder?: number | null;
  parameterType?: ReportParameters | null;
  fields: string[];
}

export interface TimeZoneReportParameterInput {
  value?: string | null;
  isAskParameter?: boolean | null;
  sortOrder?: number | null;
  parameterType?: ReportParameters | null;
  fields: string[];
}

export interface UserCallRecordingExtensionGroupInput {
  userCallRecordingExtensionGroupId?: any | null;
  userId?: number | null;
  extensionGroupId?: any | null;
  isInclude?: boolean | null;
  extensionGroupExtensions?: ExtensionGroupExtensionInput[] | null;
  fields: string[];
}

export interface UserCallRecordingExtensionInput {
  userCallRecordingExtensionId?: any | null;
  userId?: number | null;
  extensionId?: any | null;
  isInclude?: boolean | null;
  fields: string[];
}

export interface UserInput {
  userId?: number | null;
  username?: string | null;
  name?: string | null;
  emailAddress?: string | null;
  directorySourceId?: any | null;
  isSystemUser?: boolean | null;
  accountId?: any | null;
  extensionId?: any | null;
  isActive?: boolean | null;
  isLocked?: boolean | null;
  lockoutDate?: any | null;
  isForcePasswordChange?: boolean | null;
  hasAllExtensionRecordings?: boolean | null;
  failedLoginAttempts?: any | null;
  lastPasswordChangeDate?: any | null;
  lastLoggedIn?: any | null;
  isAdmin?: boolean | null;
  isPasswordMigrated?: boolean | null;
  externalId?: string | null;
  privileges?: UserPrivilegeInput[] | null;
  accountName?: string | null;
  timeZoneId?: TimeZones | null;
  roles?: UserRoleInput[] | null;
  userReports?: UserReportInput[] | null;
  userCallRecordingExtensions?: UserCallRecordingExtensionInput[] | null;
  accessTokens?: AccessTokenInput[] | null;
  userCallRecordingExtensionGroups?: UserCallRecordingExtensionGroupInput[] | null;
  fields: string[];
}

export interface UserPostInput {
  userId?: number | null;
  username?: string | null;
  name?: string | null;
  emailAddress?: string | null;
  password?: string | null;
  isSystemUser?: boolean | null;
  isAdmin?: boolean | null;
  isActive?: boolean | null;
  accountId?: any | null;
  extensionId?: any | null;
  isLocked?: boolean | null;
  isPasswordMigrated?: boolean | null;
  hasAllExtensionRecordings?: boolean | null;
  roles?: UserRoleInput[] | null;
  userReports?: UserReportInput[] | null;
  userCallRecordingExtensions?: UserCallRecordingExtensionInput[] | null;
  userCallRecordingExtensionGroups?: UserCallRecordingExtensionGroupInput[] | null;
  fields: string[];
}

export interface UserPrivilegeInput {
  userPrivilegeId?: any | null;
  privilegeId?: number | null;
  userId?: number | null;
  accountId?: any | null;
  isAdd?: boolean | null;
  isView?: boolean | null;
  isEdit?: boolean | null;
  isDelete?: boolean | null;
  isEnabled?: boolean | null;
  fields: string[];
}

export interface UserReportInput {
  userReportId?: any | null;
  userId?: number | null;
  reportId?: number | null;
  fields: string[];
}

export interface UserRoleInput {
  userRoleId?: any | null;
  userId?: number | null;
  roleId?: any | null;
  fields: string[];
}

export interface WaitTimesTileReportParametersInput {
  timeRange?: TimeRangeReportParameterInput | null;
  selectedAccount?: SelectedAccountReportParameterInput | null;
  callQueues?: CallQueueExtensionsToIncludeReportParameterInput | null;
  accountId?: any | null;
  aggregateQueues?: AggregateQueuesReportParameterInput | null;
  tileLayoutConfiguration?: TileLayoutConfigurationParameterInput | null;
  limit?: number | null;
  aggregateRest?: boolean | null;
  timeZone?: TimeZoneReportParameterInput | null;
  fields: string[];
}

//==============================================================
// END Enums and Input Objects
//==============================================================
